/* eslint-disable import/prefer-default-export */
/* eslint-disable no-var */
// tslint:disable-next-line:no-var-keyword
var tinymce;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
tinymce = tinymce || {};
var ezdia;
(function (ezdia) {
    var _a = (ezdia.config || {}).pageParams, pageParams = _a === void 0 ? {} : _a;
    ezdia.config = {
        pageParams: __assign({}, pageParams),
        validate_key: {
            unique: {
                index: 'ez.validate.unique.index',
                key: 'ez.validate.unique'
            }
        },
        VISUAL_STATUS_MAPPING: {
            'In Initial Processing': 'In Initial Processing',
            'In Topic Creation': 'In Topic Creation',
            'In Topic Approval': 'In Topic Approval',
            'Topic Approved': 'Topic Approved',
            'Topic Sent for Rework': 'Topic Sent for Rework',
            'In Keyword Research': 'In Keyword Research',
            'In Writing': 'In Writing',
            'In Editing': 'In Editing',
            'In QA': 'In QA',
            Delivered: 'Delivered',
            Approved: 'Approved',
            'Sent for Rework': 'Sent for Rework',
            'In Publishing': 'In Publishing',
            Published: 'Published',
            Reopened: 'Reopened',
            Reopen: 'Reopened',
            Reassigned: 'Reassigned',
            Returned: 'Returned'
        },
        STATUS_CSS_MAPPING: {
            'In Initial Processing': 'label label-processing-standard',
            Processing: 'label label-processing-standard',
            'In Topic Creation': 'label label-processing-standard',
            'In Topic Approval': 'label label-progression-one-standard',
            'Topic Approved': 'label label-actionsuccess-standard',
            'Topic Sent for Rework': 'label label-softalert-standard',
            'In Research': 'label label-progression-one-standard',
            'In Review': 'label label-progression-one-standard',
            'In Keyword Research': 'label label-progression-one-standard',
            'Keyword Research': 'label label-progression-one-standard',
            'In Writing': 'label label-progression-two-standard',
            Writing: 'label label-progression-two-standard',
            'In Editing': 'label label-progression-three-standard',
            'In Verification': 'label label-progression-three-standard',
            'In Audit': 'label label-progression-four-standard',
            Editing: 'label label-progression-three-standard',
            'In QA': 'label label-progression-four-standard',
            'In Keyword QA': 'label label-progression-four-standard',
            'In QA Review': 'label label-progression-four-standard',
            'In DBA Review': 'label label-progression-four-standard',
            QA: 'label label-progression-four-standard',
            Delivered: 'label label-actionsuccess-standard',
            Completed: 'label label-actionsuccess-standard',
            Approved: 'label label-progression-three-standard',
            'Sent for Rework': 'label label-softalert-standard',
            'In Publishing': 'label label-progression-four-standard',
            Published: 'label label-progression-four-standard',
            Returned: 'label label-processing-standard',
            'Returned to Client': 'label label-processing-standard',
            New: 'label label-processing-standard',
            Assigned: 'label label-actionsuccess-standard',
            'Re-Assigned': 'label label-actionsuccess-standard',
            Saved: 'label label-softalert-standard',
            Submitted: 'label label-progression-three-standard',
            Deliverable: 'label label-progression-four-standard',
            Reassigned: 'label label-actionsuccess-standard',
            Reopened: 'label label-alert-standard',
            Reopen: 'label label-alert-standard'
        },
        PROJECT_TYPE_CSS_MAPPING: {
            'Product Page': 'label-light-blue',
            'Category Page': 'label-light-green',
            'Buying Guide': 'label-amber',
            'Onsite Blog': 'label-indigo',
            'Offsite Blog': 'label-deep-orange',
            Article: 'label-cyan',
            'Web Page': 'label-pink'
        },
        COLOR_PALETTE: [],
        COUNTRIES_LIST: [
            'Afghanistan',
            'Albania',
            'Algeria',
            'American Samoa',
            'Andorra',
            'Angola',
            'Anguilla',
            'Antigua & Barbuda',
            'Argentina',
            'Armenia',
            'Aruba',
            'Australia',
            'Austria',
            'Azerbaijan',
            'Bahamas, The',
            'Bahrain',
            'Bangladesh',
            'Barbados',
            'Belarus',
            'Belgium',
            'Belize',
            'Benin',
            'Bermuda',
            'Bhutan',
            'Bolivia',
            'Bosnia & Herzegovina',
            'Botswana',
            'Brazil',
            'British Virgin Is.',
            'Brunei',
            'Bulgaria',
            'Burkina Faso',
            'Burma',
            'Burundi',
            'Cambodia',
            'Cameroon',
            'Canada',
            'Cape Verde',
            'Cayman Islands',
            'Central African Rep.',
            'Chad',
            'Chile',
            'China',
            'Colombia',
            'Comoros',
            'Congo, Dem. Rep.',
            'Congo, Repub. of the',
            'Cook Islands',
            'Costa Rica',
            "Cote d'Ivoire",
            'Croatia',
            'Cuba',
            'Cyprus',
            'Czech Republic',
            'Denmark',
            'Djibouti',
            'Dominica',
            'Dominican Republic',
            'East Timor',
            'Ecuador',
            'Egypt',
            'El Salvador',
            'Equatorial Guinea',
            'Eritrea',
            'Estonia',
            'Ethiopia',
            'Faroe Islands',
            'Fiji',
            'Finland',
            'France',
            'French Guiana',
            'French Polynesia',
            'Gabon',
            'Gambia, The',
            'Gaza Strip',
            'Georgia',
            'Germany',
            'Ghana',
            'Gibraltar',
            'Greece',
            'Greenland',
            'Grenada',
            'Guadeloupe',
            'Guam',
            'Guatemala',
            'Guernsey',
            'Guinea',
            'Guinea-Bissau',
            'Guyana',
            'Haiti',
            'Honduras',
            'Hong Kong',
            'Hungary',
            'Iceland',
            'India',
            'Indonesia',
            'Iran',
            'Iraq',
            'Ireland',
            'Isle of Man',
            'Israel',
            'Italy',
            'Jamaica',
            'Japan',
            'Jersey',
            'Jordan',
            'Kazakhstan',
            'Kenya',
            'Kiribati',
            'Korea, North',
            'Korea, South',
            'Kuwait',
            'Kyrgyzstan',
            'Laos',
            'Latvia',
            'Lebanon',
            'Lesotho',
            'Liberia',
            'Libya',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Macau',
            'Macedonia',
            'Madagascar',
            'Malawi',
            'Malaysia',
            'Maldives',
            'Mali',
            'Malta',
            'Marshall Islands',
            'Martinique',
            'Mauritania',
            'Mauritius',
            'Mayotte',
            'Mexico',
            'Micronesia, Fed. St.',
            'Moldova',
            'Monaco',
            'Mongolia',
            'Montserrat',
            'Morocco',
            'Mozambique',
            'Namibia',
            'Nauru',
            'Nepal',
            'Netherlands',
            'Netherlands Antilles',
            'New Caledonia',
            'New Zealand',
            'Nicaragua',
            'Niger',
            'Nigeria',
            'N. Mariana Islands',
            'Norway',
            'Oman',
            'Pakistan',
            'Palau',
            'Panama',
            'Papua New Guinea',
            'Paraguay',
            'Peru',
            'Philippines',
            'Poland',
            'Portugal',
            'Puerto Rico',
            'Qatar',
            'Reunion',
            'Romania',
            'Russia',
            'Rwanda',
            'Saint Helena',
            'Saint Kitts & Nevis',
            'Saint Lucia',
            'St Pierre & Miquelon',
            'Saint Vincent and the Grenadines',
            'Samoa',
            'San Marino',
            'Sao Tome & Principe',
            'Saudi Arabia',
            'Senegal',
            'Serbia',
            'Seychelles',
            'Sierra Leone',
            'Singapore',
            'Slovakia',
            'Slovenia',
            'Solomon Islands',
            'Somalia',
            'South Africa',
            'Spain',
            'Sri Lanka',
            'Sudan',
            'Suriname',
            'Swaziland',
            'Sweden',
            'Switzerland',
            'Syria',
            'Taiwan',
            'Tajikistan',
            'Tanzania',
            'Thailand',
            'Togo',
            'Tonga',
            'Trinidad & Tobago',
            'Tunisia',
            'Turkey',
            'Turkmenistan',
            'Turks & Caicos Is',
            'Tuvalu',
            'Uganda',
            'Ukraine',
            'United Arab Emirates',
            'United Kingdom',
            'United States',
            'Uruguay',
            'Uzbekistan',
            'Vanuatu',
            'Venezuela',
            'Vietnam',
            'Virgin Islands',
            'Wallis and Futuna',
            'West Bank',
            'Western Sahara',
            'Yemen',
            'Zambia',
            'Zimbabwe'
        ],
        CUS_EVENTS: {
            FORM_EVENT_STICK: 'ez.form.scroll.stick',
            FORM_EVENT_FREE: 'ez.form.scroll.free'
        },
        COLLAPSE_GRID_WIDTH: 375,
        GRID_CHECKBOX_WIDTH: 25,
        GRID_BASE_COLUMN_WIDTH: 150,
        GRID_WIDTH_MARGIN: 30,
        HEADER_HEIGHT: 51,
        IDS: {
            PREFIX: 'ez_js__',
            SHOW_HISTORY_PREFIX: 'ez_js__show-history__',
            SHOW_PARENTVALUE_PREFIX: 'ez_js__show-parentValue__',
            QUICK_ACTIONS_PARENT: 'ez-js-quick-action-grid-links'
        },
        GRID_DATA: {},
        metadata: {},
        GRID_EDITABLE_FIELDS: {},
        JS: {
            currentAccountKey: '',
            activityTime: {},
            sessionQKey: 'sqk',
            sessionDKey: 'sdk'
        }
    };
    ezdia.CONST = {
        DEV_COOKIE_KEYS: {
            DEBUG: 'debug',
            TEST: 'test'
        }
    };
})(ezdia || (ezdia = {}));
